import { TextBox } from '@apply/components';
import { useBorrowerEsignTypedName } from '../../../../../queries/BorrowerFields/EsignFields';

export const TypedName: React.FC = () => {
    const [typedName, set_typedName] = useBorrowerEsignTypedName();
    return (
        <TextBox
            value={typedName ?? ''}
            onChange={(value) => set_typedName(value)}
            label='Typed Name'
            required={true}
        />
    );
};
